// Process task list items
// Detect [ ] and [x] markers at the beginning of list items

import type StateCore from '../state-core'

// Regex to match task list item marker at the start of content
// Matches: [ ] or [x] or [X] followed by whitespace
const TASK_ITEM_REGEX = /^\[([ xX])\][ \t]/

export default function tasklist(state: StateCore) {
  const tokens = state.tokens

  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i]

    // Only process list items
    if (token.type !== 'list_item_open') {
      continue
    }

    // Find the first inline token in this list item
    // List structure: list_item_open -> (paragraph_open -> inline -> paragraph_close) | (other blocks) -> list_item_close
    let inlineTokenIdx = -1
    let _paragraphOpenIdx = -1

    // Look for the first paragraph in this list item
    for (let j = i + 1; j < tokens.length; j++) {
      if (
        tokens[j].type === 'list_item_close' &&
        tokens[j].level === token.level
      ) {
        break
      }

      if (
        tokens[j].type === 'paragraph_open' &&
        tokens[j].level === token.level + 1
      ) {
        _paragraphOpenIdx = j
        // The inline token should be right after paragraph_open
        if (j + 1 < tokens.length && tokens[j + 1].type === 'inline') {
          inlineTokenIdx = j + 1
        }
        break
      }

      // For tight lists, the first block might be inline directly
      if (tokens[j].type === 'inline' && tokens[j].level === token.level + 1) {
        inlineTokenIdx = j
        break
      }
    }

    if (inlineTokenIdx === -1) {
      continue
    }

    const inlineToken = tokens[inlineTokenIdx]
    const content = inlineToken.content

    // Check if content starts with task list marker
    const match = content.match(TASK_ITEM_REGEX)
    if (!match) {
      continue
    }

    const checked = match[1] !== ' '

    // Mark the list_item_open token as a task list item
    token.attrSet('data-task', 'true')
    token.attrSet('data-task-checked', checked ? 'true' : 'false')

    // Store in meta for easier access
    if (!token.meta) {
      token.meta = {}
    }
    token.meta.task = true
    token.meta.taskChecked = checked

    // Remove the task marker from the inline content
    // We keep the marker in the content and let the renderer handle it
    // This preserves the original markdown structure

    // Alternative approach: Remove marker from content
    // inlineToken.content = content.slice(match[0].length)

    // Update children if they exist
    if (inlineToken.children && inlineToken.children.length > 0) {
      const firstChild = inlineToken.children[0]
      if (firstChild.type === 'text') {
        const childMatch = firstChild.content.match(TASK_ITEM_REGEX)
        if (childMatch) {
          // Remove the task marker from the first text token
          firstChild.content = firstChild.content.slice(childMatch[0].length)

          // Also update the parent inline token content
          inlineToken.content = inlineToken.content.slice(childMatch[0].length)
        }
      }
    }
  }
}
